<template>
  <div class="panel-admin-body">
    <survey-status :input-survey="survey" :display-survey-status="!isSurveyEmpty" :url="liveSurveyUrl"
      :does-survey-url-work="this.doesSurveyUrlWork"></survey-status>
    <div class="d-flex title">
      <div class="pb-1"><modal-link modal-id="How to Use" :content-list="pageContent"></modal-link>{{ title }}</div>
      <div class="ml-auto">
        <i v-show="this.$root.getShowMenuIcon() && this.$root.getShowHeaderMenu()"
          class="fa fa-window-minimize pl-1 pr-1" aria-hidden="true" @click="toggleHeaderMenu()"></i>
        <i v-show="this.$root.getShowMenuIcon() && !this.$root.getShowHeaderMenu()"
          class="fa fa-window-maximize pl-1 pr-1" aria-hidden="true" @click="toggleHeaderMenu()"></i>
      </div>
    </div>
    <saved-card-menu :entry-client-object="clientObject" :original-saved-cards="clientChartsBySurvey" set-type="survey" view-type="menu"></saved-card-menu>
    <div v-if="permissionToView">
      <div v-if="getDisplayView()" class="ideal needs-command-center-area">
        <div class="row no-gutters justify-content-left">
          <div class="design-column col-9" style="max-width: 924px;">
            <div class="row w-100">
              <div class="needs-command-center-name-section">
                <div class="section-title col-6">Functional Needs</div>
                <div class="section-label col-6 text-center">Names</div>
              </div>
              <div class="section-label needs-command-center-column text-center">Metric Relationship</div>
              <div class="section-label needs-command-center-column text-center">Ideas Relationship</div>
              <div class="section-label col-2 text-center">Drive Bond</div>
            </div>
          </div>
          <div class="section-label col-2 text-center">
            <div class="form-row form-group form-inline">
              <modal-link modal-id="Enable Description Pop-up"  :content-list="pageContent"></modal-link>
              <survey-field
                :survey-id="this.survey.surveyId"
                :survey-field-object="this.getSurveyField('enable-description-popup')"
                field-type="checkbox"
                field-class="form-group form-inline"
                field-label="Enable Description Pop-up"
                :build-survey="false"
                default-field-name="enable-description-popup"
                default-field-value="N"
                @save="this.saveSurveyField"
              ></survey-field>
            </div>
        </div>
        </div>
        <div class="row no-gutters justify-content-left">
          <div class="design-column col-9" style="max-width: 924px;">
            <needs-section :section-object="this.getSection('Actual Functional Needs')"
              :survey-id="this.survey.surveyId"></needs-section>
          </div>
          <div class="col-2">
            <div v-show="enableDescriptionPopup == true" class="question-description-container">
              <div class="question-description" v-for="(question, idxQuestion) in this.getQuestions()" v-bind:key="idxQuestion">
                <question-description
                    v-if="displayQuestions"
                    :question-object="question"
                    @save="setSurveyToBuildRequired"
                ></question-description>
              </div>
            </div>
          </div>
        </div>
        <div class="section-border"></div>
        <div class="row no-gutters justify-content-left">
            <div class="design-column col-9">
              <div class="row w-100 pt-2">
                <div class="needs-command-center-name-section">
                  <div class="section-title col-6">Emotional Needs</div>
                  <div class="section-label col-6 text-center">Names</div>
                </div>
                <div class="section-label needs-command-center-column text-center">Metric Relationship</div>
                <div class="section-label needs-command-center-column text-center">Ideas Relationship</div>
                <div class="d-none section-label col-2 text-center">Drive Bond</div>
              </div>
            </div>
            <div class="section-label col-2 text-center"></div>
        </div>
        <div class="row no-gutters justify-content-left">
          <div class="design-column" style="width: 763px;">
            <needs-section :section-object="this.getSection('Actual Emotional Needs')" :survey-id="this.survey.surveyId"
              @save="this.saveSurveyField"></needs-section>
            <div class="d-none dashboard-divider pt-3"></div>
          </div>
          <div class="d-none design-column col-4">
            <survey-drivers :input-survey-drivers="surveyDrivers" :survey-id="this.survey.surveyId"
              @save="updateSurveyDrivers" @enable-save-order-button="enableSaveOrderButton">
            </survey-drivers>
          </div>
        </div>
        <div class="row no-gutters pt-2">
          <div class="col" role="group">
            <button type="submit" class="btn btn-primary float-right" :disabled="this.error || this.disableButton"
              @click="saveSurvey()">
              <span>{{ buttonText }} </span>
              <span v-show="this.$root.getLoading()" class="spinner-border spinner-border-sm"></span>
            </button>
            <button type="submit" class="btn btn-primary float-right mr-4"
              :disabled="this.error || this.disableSaveOrderButton" v-on:click="this.saveSurveyDriverOrder">
              <span>Save Order</span>
              <span v-show="this.$root.getLoading()" class="spinner-border spinner-border-sm"></span>
            </button>
          </div>
        </div>
        <div v-for="(pageContent, idxPageContent) in pageContent" v-bind:key="idxPageContent">
          <modal :modal-id="pageContent.title" :modal-title="pageContent.title" :modal-content="pageContent.contentText" />
        </div>
      </div>
    </div>
    <div v-else class="ideal text-center">You do not have permission to view this page</div>
  </div>
</template>
<script>
import AdminService from "../../services/admin.service";
import SurveyService from "../../services/survey.service";
import GoogleService from "../../services/google.service";
import ErrorService from "../../services/error.service";
import QuestionDescription from "../../components/QuestionDescription.vue";
import StudyDesignMixins from "../../mixins/StudyDesignMixins.vue";
import NeedsSection from "../../components/NeedsSection.vue";
import SurveyStatus from "../../components/SurveyStatus.vue";
import SurveyDrivers from "../../components/SurveyDrivers.vue";
import SurveyField from "../../components/SurveyField.vue";
export default {
  name: "Needs",
  mixins: [StudyDesignMixins],
  components: {
    NeedsSection,
    SurveyDrivers,
    SurveyField,
    QuestionDescription,
    SurveyStatus
  },
  props: {},
  data() {
    return {
      surveyName: "",
      pageNumber: 3,
      displayQuestions: false,
      title: "Needs",
      surveyDrivers: ["", "", "", "", ""],
      disableSaveOrderButton: true,
      buildSurvey: true
    };
  },
  methods: {
    setSurveyToBuildRequired() {
      this.saveBuildRequired("Y");
    },    
    enableSaveOrderButton(){
      this.disableSaveOrderButton = false;
      this.disableButton = true;
    },
    postLoadData: function() {
      this.setDisplayView(true);
      this.displayQuestions = true;
    },
    updateSurveyDrivers: function(data){
      this.surveyDrivers =  JSON.parse(JSON.stringify(data));
    },
    saveSurveyDriverOrder(){
      this.$root.processServerRequest("Saving driver order");
      GoogleService.logClickEvent(SurveyService.getSurveyName(), "Save Order - Driver", 0, this);

      this.disableSaveOrderButton = true;
      SurveyService.saveSurveyDriverOrder(this.surveyDrivers, this.survey.surveyId, this.saveSurveyDriverOrderCallback, this);
    },    
    saveSurveyDriverOrderCallback(response){
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.updateSurveyDrivers(response.data.data);
        AdminService.displaySuccessMessage({ text: response.data.message });
        this.disableButton = false;
      } else {
        ErrorService.processError("Needs.saveSurveyDriverOrderCallback", response.data.message, "survery-designer", this);
      }
    },   
    getQuestions(){
      let questions = this.getSection('Actual Functional Needs').questions;
      questions.sort(function(a, b) {
        let positionA = a.designViewSequenceNumber;
        let positionB = b.designViewSequenceNumber;
        return positionA - positionB;
      });
      return questions;
    } 
  },
  created() {},
  mounted() {
    
  },
  computed: {
    enableDescriptionPopup: function() {
      if (typeof this.getSurveyField("enable-description-popup") == "undefined") {
        return false;
      }
      return this.getSurveyField("enable-description-popup").surveyFieldValue == "Y";
    },    
    buttonText: function() {
      return this.survey.buildRequired == "N" ? "Save" : "Build Survey";
    }
  }
};
</script>
